import {Quote, WorkEventStatus} from "../types";

// A quote holds no dates of its own, its span is derived from the events attached to it.
// Deleted events are ignored, they no longer describe work the quote covers.
const getQuoteEventTimes = (quote: Partial<Quote>, field: 'start_date' | 'end_date') => {
    return (quote.event_set ?? [])
        .filter(event => event.status !== WorkEventStatus.deleted)
        .map(event => new Date(event[field]).getTime())
        .filter(time => !isNaN(time))
}

// Earliest start date across the quote's events, undefined when it has none
export const getQuoteStartDate = (quote: Partial<Quote>) => {
    const times = getQuoteEventTimes(quote, 'start_date')
    return times.length ? new Date(Math.min(...times)).toISOString() : undefined
}

// Latest end date across the quote's events, undefined when it has none
export const getQuoteEndDate = (quote: Partial<Quote>) => {
    const times = getQuoteEventTimes(quote, 'end_date')
    return times.length ? new Date(Math.max(...times)).toISOString() : undefined
}
